<!-- NOTICES -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION (GENERIC) -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> 
                            <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>                                                
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS (CUSTOM) -->
                <v-col :cols="computedCols" class="px-2 pb-1">
                    <v-row dense class="d-flex justify-end">
                        <v-col cols="12" xs="12" sm="12" md="6" class="">
                            <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="" v-if="$vuetify.breakpoint.lgAndUp && ['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.type" :items="noticeTypes" item-text="text" item-value="value" filled dense clearable :label="$t(`filters.type`)" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="" v-if="$vuetify.breakpoint.lgAndUp && ['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.site" :items="sites" item-text="siteName" item-value="id" filled dense clearable :label="$t(`filters.site`)" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp && ['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t(`filters.sortBy`)" hide-details>
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * STATUS AND BUTTONS -->
                <v-col cols="12" class="pl-2 pr-0 d-flex align-center">
                        <!-- // * STATUS FILTER (CUSTOM) -->
                        <div v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-btn-toggle v-model="filter.status" multiple color="white" active-class="white" background-color="lightgrey" dense >
                              <v-btn value="LIVE"><v-icon class="success--text icons8-checkmark-yes"></v-icon><span class="success--text caption hidden-sm-and-down">{{ $t(`status.live`) }}</span></v-btn>
                              <v-btn value="DRAFT"><v-icon class="grey--text text--lighten-1 icons8-inactive-state"></v-icon><span class="grey--text caption hidden-sm-and-down">{{ $t(`status.draft`) }}</span></v-btn>
                            </v-btn-toggle>
                        </div>
                        <!-- // * SHOW DELETED (GENERIC) -->
                        <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp && ['DA'].includes(GET_currentUser.userLevel)">
                            <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                            <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" inset color="purple"></v-switch>                                            
                        </div>
                        <v-spacer></v-spacer>
                        <!-- // * BUTTONS -->
                        <div v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)"><appbutton :label="$t(`buttons.add`)" icon="icons8-note" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem('', 'New', false)" /></div>
                        <div v-if="$vuetify.breakpoint.mdAndUp && ['SM','SA','DA'].includes(GET_currentUser.userLevel)"><appbutton :label="$t(`buttons.columns`)" icon="icons8-select-column" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="columnsDialog = true" /></div>
                        <div v-if="$vuetify.breakpoint.mdAndUp && ['SM','SA','DA'].includes(GET_currentUser.userLevel)" class="pr-1"><appbutton :label="$t(`buttons.export`)" icon="icons8-export-csv" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="mix_exportDocuments(headersCSV,'Notices',formatExport)" /></div>
                </v-col>
                <!-- // * TABLE -->
                <v-col class="px-2 mt-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search"
                        >
                        <!-- // HEADERS (GENERIC) -->                        
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>     
                        <!-- // STATUS (CUSTOM) -->             
                        <template v-slot:[`item.noticeStatus`]="{ item }">
                            <v-icon v-if="item.noticeStatus === 'LIVE'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                            <v-icon v-if="item.noticeStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>
                        </template>
                        <!-- // NAME (CUSTOM) -->
                        <template v-slot:[`item.noticeName`]="{ item }">
                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text d-inline-block text-truncate" style="max-width: 200px;"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.noticeName}}</span>
                            <span v-else class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.noticeName }}</span>
                        </template>
                        <!-- // NOTICE TYPE -->
                        <template v-slot:[`item.noticeType`]="{ item }">
                            {{ lookupField('noticeTypes', 'text', item.noticeType)  }}
                        </template>                        
                        <!-- // SITE DATA -->
                        <template v-slot:[`item.site`]="{ item }">
                            <div class="d-flex align-center">
                                <v-icon>icons8-apartment</v-icon>      
                                {{ item.site.siteName }}
                            </div>
                        </template>
                        <!-- // ACTION (GENERIC) -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                        </template>
                        <!-- // CREATED USER DATA (GENERIC) -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>                                                        
                        <!-- // MODIFIED USER DATA (GENERIC) -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.modifiedUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA (GENERIC) -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata mb-8" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id" @click="openItem(item.id, 'View', false)">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="2" class="">
                                    <!-- // TODO MEED TO MAKE THIS GENERIC -->
                                    <v-icon v-if="item[`${collectionItem}Status`] === 'LIVE'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                    <v-icon v-if="item.noticeStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>
                                </v-col>
                                <v-col cols="7" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect"><span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.noticeName }}</span></div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.noticeType }}</div>
                                    <div class="caption noselect">{{ MIX_fromNow(item.createdDateTime, 'DD-MMM-YY HH:mm', true) }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right"><v-icon @click=" (item.id, 'View', false)">mdi-chevron-right</v-icon></v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright  />
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in">
            <rightpanel></rightpanel>
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->        
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{$t('miscHeadings.showHideColumns')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                          <v-list-item-title><v-checkbox color="grey darken-1" hide-details v-model="headers[index].hidden" :false-value="true" :true-value="false" :label="$t(`fields.${header.text}`)"></v-checkbox></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
    </v-row>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            collection: 'notices',
            collectionTitle: 'Notices',
            collectionItem: 'notice',
            collectionItemTitle: 'Notice',  
            langPath: 'notices',
            columnsDialog: false,
            search: '', // Table Search
            sortBy: 'createdDateTime', // Default Table Sort By
            customWhere: [],
            filter: {
                // Default Filters
                sortAsc: false,
                status: ['LIVE', 'DRAFT'],
                type: '',
            },
            tableData: [], // Table Data
            headers: [ // Table Headers
                // hidden shows the initial value of the column - hidden or visible
                // hides determines if you want to hide the column on screen resize
                { text: 'status', value: 'noticeStatus', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'id', value: 'id', sortable: false, align: 'left', hidden: true, hide: true },                
                { text: 'name', value: 'noticeName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'type', value: 'noticeType', align: 'left', sortable: false, hidden: false, hide: false },                
                { text: 'site', value: 'site', align: 'left', sortable: false, hidden: false, hide: false },                
                { text: 'created', value: 'createdDateTime', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'delete', value: 'delete', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false,  hide: false },
            ],
            headersCSV: {
                id: 'Access ID',
                noticeStatus: 'Status',
                noticeName: 'Name',
                noticeDescription: 'Description',
                noticeType: 'Type',
                createdDateTime: 'Created Date and Time',
                createdUserData: 'Created By',
                modifiedDateTime: 'Modified Date and Time',
                modifiedUserData: 'Modified By',
            },
            // EXPORT
            exportData: [],
            // LOOKUP VALUES
            noticeTypes: [],
            noticeSeverities: [],
            sites: [],
            // DELETED
            showDeleted: false,
            filteredHeaders: []
        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_lookupValues: 'GET_lookupValues',     
                GET_help: 'GET_help'           ,
                GET_sites: 'GET_sites'
            }),
            // EXPORT
            formatExport() {
                this.exportData = JSON.parse(JSON.stringify(this.computedTableData))
                return this.exportData
            },
            // Remove actions from Selectable Column Headers
            columnHeaders() {
                var t = this;
                var headers = t.headers;
                return (headers.filter((header) => {
                    return header.value !== 'actions'
                }));
            },
            // // Computed Table Headers            
            // computedHeaders() {
            //     var t = this;
            //     var headers = t.headers;
            //     return (t.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Computed Cols
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
            // Computed Table Data
            computedTableData() {
                var t = this;
                var tableData = t.tableData;
                // Filter by status
                tableData = tableData.filter(function(item) {
                    return t.filter.status.includes(item[t.collectionItem+'Status']);
                });
                // Filter by type
                if ((t.filter.type !== '') && (t.filter.type !== undefined) && (t.filter.type !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.type === item[t.collectionItem + 'Type'];
                    });
                }
                // Filter by Site
                if ((t.filter.site !== '') && (t.filter.site !== undefined) && (t.filter.site !== null)) {       
                    tableData = tableData.filter(function(item) {
                        return t.filter.site === item.site.siteName;
                    });
                }
                // Filter by Search Mobile                
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item[t.collectionItem+'Name'].toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        noticeStatus: e.noticeStatus,
                        noticeName: e.noticeName,
                        noticeDescription: e.noticeDescription,
                        noticeType: e.noticeType,
                        site: e.site,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                tableDataList = tableDataList.sort(function(a, b) {
                    return new Date(a.createdDateTime) - new Date(b.createdDateTime)
                })
                // Sort the Table by the Field in the Sort By Filter
                if (t.sortBy !== 'createdDateTime') {
                    tableDataList = t.$sortBy(tableDataList, t.sortBy)
                }
                if (!t.filter.sortAsc) {tableDataList.reverse()}
                return (tableDataList);      
            }
        },
        // * WATCH
        watch: {
            GET_currentUser: {
                handler() {
                    this.getTableData();
                }, deep: true
            },
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }            
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openNotice'}),
            // UPDATE BREADCRUMBS (GENERIC)
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM (GENERIC)
            openItem: async function(id, process, popup) {
                var t = this;
                var item = {}                
                t.dynamicComponentKey++; 
                item.process = process;
                item.popup = popup;
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collection, id)
                    item.data = itemResult.data;
                } else {
                    item.data = null;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem);
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem);
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            // GET TABLE DATA SNAPSHOT METHOD (GENERIC)
            getTableData: async function () {
                var t = this;
                var collection = t.$firebase.db.collection(t.collection)
                if (JSON.stringify(t.customWhere) !== '[]') {
                    for (var i = 0; i < t.customWhere.length; i++) {
                        var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                        collection = collection.where(query.field, query.operator, query.value)   
                    }
                }
                collection.onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },
            // LOOKUP FIELD (GENERIC)
            lookupField: function(lookup, field, value) {
                var t = this;
                var lookupResult = t.$find(t[lookup], { value: value })
                if (lookupResult !== undefined) {
                    return (lookupResult)[field];
                } else {
                    return ('NOTFOUND')
                }
            }     
        },
        // * MOUNTED
        async mounted() {
            // GENERIC MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
            // GET SITES
            await t.MIX_sites(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY       
            // INSERT CUSTOM WHERES HERE
            // t.customWhere.push ({ key: '', operator: '==', value: '' });
            t.getTableData(); // Get Table Data   
            // LOOKUPS (CUSTOM)
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.noticeTypes = await t.GET_lookupValues('NOTICETYPES');
            // GET SITES
            await t.MIX_sites(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY         
            // AUTO OPEN (GENERIC)
            // * AUTO OPEN SITE IF PATH CONTAINS SITEID
            if ((window.location.pathname !== `/${t.collection}` && window.location.pathname !== `/${t.collection}/`)) {
                var urlPath = window.location.pathname.split('/');
                var id = urlPath[2];
                if (id === 'new') {
                    t.openItem('', 'New', false)
                } else {
                    t.openItem(id, 'View', false)
                }
            }                    
        },
    }
</script>